import React, { useState } from 'react';
import { useModuleContext } from 'context/ModuleProvider';
import { useHistory, useLocation } from 'react-router-dom';
import Payment from './Payment';
import ZoomPayment from './ZoomPayment';
import queryString from 'query-string';

let types = [
  { id: 'subscription', title: 'Subscriptions' },
  { id: 'zoomplan', title: 'Zoom Class' },
];

function SubscriptionPlans() {
  let { moduleId } = useModuleContext();
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const [selectedCategoryType, setSelectedCategoryType] = useState(type || 'subscription');

  const handleClose = function () {
    if (history.length > 1) {
      // this will take you back if there is history
      history.goBack();
    } else {
      history.pushState(`${moduleId}/dashboard`);
    }
  };

  const setSearchParam = (key, value) => {
    const currentParams = queryString.parse(location.search);
    currentParams[key] = value;

    const newSearch = queryString.stringify(currentParams);
    history.push(`${location.pathname}?${newSearch}`);
  };

  return (
    <div className="payment_main">
      <div className="container">
        <div className="row d-flex justify-content-center align-content-center align-items-center">
          <div className="col-md-4 col-sm-12 d-md-block d-none">
            <article className="payment__img">
              <div className="swiper-slide">
                <img src="/images/subscribe.jpg" alt="Video courses" loading="lazy" />
                <div className="pt-5 text-center">
                  <h5 className="d-block fw-500 pr-0 mb-0">Subject wise video &amp; tutorials</h5>
                  <p className="small text-muted">Live MCQ Tests, discussion & polls</p>
                </div>
              </div>
            </article>
          </div>
          <div className="col-md-8 col-sm-12 px-md-2 px-0">
            <div className="form-box px-md-4 px-sm-2 px-0">
              <main className="payment">
                <article className="payment__form my-sm-4 my-1">
                  <div className="back-element d-block py-2" style={{ position: 'relative' }}>
                    <div onClick={handleClose} className="text-muted" style={{ cursor: 'pointer' }}>
                      <i className="fas fa-arrow-left"></i>
                    </div>
                  </div>
                  <h1 className="payment__question mb-1" style={{ fontSize: '20px', marginRight: '10px' }}>
                    <img src="/images/nameOnline.png" width="100px" alt="Video courses" loading="lazy" />
                    {selectedCategoryType === types[0].id ? 'Subscription Plans' : 'Zoom Class Plans'}
                  </h1>
                  <div class="row d-flex justify-content-between mb-2">
                    <span className="d-block small" style={{ fontSize: '12px' }}>
                      Please choose a plan to proceed
                    </span>
                    {selectedCategoryType === types[0].id && (
                      <a
                        href="#subDetail"
                        className="d-block text-muted font-weight-light text-underline small pl-2 no-wrap"
                        data-toggle="modal"
                        data-target="#subDetail"
                      >
                        <i className="fa fa-info-circle" />
                        &nbsp;What's included?
                      </a>
                    )}
                  </div>

                  <div className="alert alert-warning border-0" role="alert">
                    <small style={{ fontSize: '12px' }}>
                      {selectedCategoryType === types[0].id
                        ? 'No Cost EMI available on 6 months & below subscription plans.'
                        : 'Payment is attributed only to selected test and duration.'}
                    </small>
                  </div>

                  <div className="ui-tab bg-white radius-15 pl-sm-0 pr-sm-0 undefined mb-4 px-sm-3 pt-sm-0 pt-0 px-0">
                    <ul className="nav nav-tabs d-flex" id="testTab" role="tablist">
                      {types.map((t) => {
                        let { id, title } = t;
                        let selected = selectedCategoryType === id;
                        return (
                          <li className="nav-item">
                            <span
                              aria-controls={id}
                              aria-selected={selected}
                              className={`nav-link px-sm-4 py-sm-3 px-1 py-2 pl-sm-2 pl-2 ${selected && 'active'} `}
                              id={`${id}-tab`}
                              role="tab"
                              onClick={() => {
                                setSelectedCategoryType(id);
                                setSearchParam('type', id);
                              }}
                            >
                              {title}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  {selectedCategoryType === 'subscription' ? <Payment /> : <ZoomPayment />}
                </article>
              </main>
            </div>
          </div>

          {/* modal box for subscription details */}
          <div
            className="modal fade"
            id="subDetail"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="subDetailTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog"
              role="document"
              style={{
                width: '100%',
                height: '100%',
                marginTop: '1px',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <div className="modal-content" style={{ height: '100%' }}>
                <div className="modal-header" style={{ minHeight: '65px' }}>
                  <h5 className="modal-title" id="AskTitle">
                    NameOnline Subscription Details | 3 mo / 6 mo / 12 mo
                  </h5>
                  <button
                    type="button"
                    className="close btn btn-link btn-sm px-2 py-1 m-1"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body" style={{ minHeight: 'calc(100vh - 84px)' }}>
                  Your subscription plan includes:
                  <ul className="fa-ul my-2">
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>5500+ hours of High Quality Video lessons
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>Highly yield interactive courses
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>Videos by top rated Mentors
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>Interactive discussion, polls &amp;
                      ranking
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>Updated coursework, MCQ's & Mock tests
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>CEE oriented tutorials
                    </li>
                    <li>
                      <i className="fa-li fa fa-check-square text-success"></i>Unlimited Access of NameOnline
                    </li>
                  </ul>
                  <div className="alert alert-warning my-4 pl-0" role="alert">
                    <ul className="fa-ul my-2">
                      <li>
                        <i className="fa-li fa fa-angle-right text-secondary"></i>Billed as a One Time payment based
                        upon your subscribed plans.
                      </li>
                      <li>
                        <i className="fa-li fa fa-angle-right text-secondary"></i>Get more discounts on purchase of 6mo
                        & 12mo packages.
                      </li>
                    </ul>
                  </div>
                  <div className="disclaimer pt-4">
                    <i>
                      Note: The resources and materials in the NameOnline app is exclusively produced by the Name
                      Institute. Please contact Name Institute's administrator for course related queries.
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionPlans;
